export default [
  {
    path: '/streets',
    name: 'streets',
    component: () => import('@/views/index.vue'),
    meta: {
      title: 'Улицы',
    },
    children: [
      {
        path: '',
        name: 'streets-list',
        component: () => import('@/views/streets/streets.vue'),
        meta: {},
      },
      {
        path: 'add',
        name: 'streets-add',
        component: () => import('@/views/streets/add.vue'),
        meta: {
          title: 'Добавить',
        },
      },
      {
        path: ':id(\\d+)/edit',
        name: 'streets-edit',
        props: true,
        component: () => import('@/views/streets/edit.vue'),
        meta: {
          title: 'Изменить',
        },
      },
    ],
  },
]
